import { useCallback } from 'react';

export default function UrologyCareSection() {

  // Custom Scroll Smooth Function
  const handleScroll = useCallback((e) => {
    e.preventDefault();
    const target = document.getElementById('contact');
    if (!target) return;

    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    const duration = 3000; // 3000ms = 3 seconds
    let start = null;

    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const percent = Math.min(progress / duration, 1);
      window.scrollTo(0, startPosition + distance * percent);
      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    });
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center gap-10">

      {/* Left Section */}
      <div className="flex-1">
        <p className="font-semibold text-blue-700 uppercase mb-3 tracking-wide">
          Expert Urology Care
        </p>
        <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
          Your health is our priority
        </h1>
        <p className="text-gray-600 leading-relaxed mb-6">
          Dr. Srikanth V is a leading urology specialist based in Bengaluru, IN, dedicated to providing expert care for a wide range of urological services.
          He has earned the trust of over 248 patients, boasting a remarkable 98% recommendation score.
          He is the best doctor in Bengaluru, 100% recommended for urological treatments.
          Dr. Srikanth offers advanced procedures such as RIRS for kidney stones and prostate laser therapies, ensuring comprehensive care for both male and female urological needs.
          Fluent in multiple languages, he creates a welcoming environment for all.
        </p>

        {/* Smooth scroll button */}
        <button 
          onClick={handleScroll}
          className="inline-block font-semibold text-blue-700 underline underline-offset-4 hover:text-green-700 transition-colors duration-300"
        >
          Get in touch
        </button>
      </div>

      {/* Right Section */}
      <div className="flex-1">
        <img
          src="/images/srikanth_care.jpeg"
          alt="Best Urologist in Bengaluru"
          width={600}
          height={450}
          className="rounded-lg shadow-lg object-cover"
        />
      </div>

    </div>
  );
}
